import showYearPlan from './index.vue'
export default showYearPlan